if (!customElements.get('flaechen-summe')) {
  customElements.define(
    'flaechen-summe',
    class FlaechenSumme extends HTMLElement {
      constructor() {
        super();
        this.map = {};
        (this.dataset.map || '').split(';').forEach((eintrag) => {
          const [id, wert] = eintrag.split(':');
          if (id && wert) this.map[id] = parseFloat(wert);
        });
        this.variantId = this.dataset.variantId;
        this.output = this.querySelector('.flaechen-summe__input');
      }

      connectedCallback() {
        this.section = this.closest('.product') || document;
        this.quantityInput = this.section.querySelector('.quantity__input');
        if (this.quantityInput) {
          ['input', 'change'].forEach((name) => this.quantityInput.addEventListener(name, () => this.update()));
        }
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubVariant = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (event.data.sectionId !== this.dataset.sectionId) return;
            if (event.data.variant) this.variantId = String(event.data.variant.id);
            this.update();
          });
          this.unsubQuantity = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => this.update());
        }
        this.update();
      }

      disconnectedCallback() {
        if (this.unsubVariant) this.unsubVariant();
        if (this.unsubQuantity) this.unsubQuantity();
      }

      update() {
        // Fläche je Karton wie im Shop angezeigt auf 2 Stellen runden (4,335 -> 4,34), dann mal Menge
        const roh = this.map[this.variantId];
        const proKarton = roh ? Math.round(roh * 100 + 1e-9) / 100 : roh;
        const menge = this.quantityInput ? parseInt(this.quantityInput.value, 10) : 1;
        if (!proKarton || !(menge > 0)) {
          this.output.value = '';
          this.hidden = !proKarton;
          return;
        }
        this.hidden = false;
        this.output.value = (Math.round(menge * proKarton * 100) / 100).toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    }
  );
}
